<template>
  <span :class="linkClassName" v-if="user && user.name">
    <span class="logout-link__user">{{user.name}}</span>
    <span v-if="isTasador && user.tasador" class="logout-link__tasador">
        - {{ user.tasador.clave }}
    </span>
    <i @click="logout" class="logout-link__icon fas fa-sign-out-alt"></i>
  </span>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LOGOUT } from '@/store/modules/auth';

export default {
  name: 'LogoutLink',

  props: {
    light: {
      type: Boolean,
    },
  },

  computed: {
    ...mapState({
      user: ({ auth }) => auth.user,
    }),

    ...mapGetters('auth', ['isTasador']),

    linkClassName() {
      return {
        'logout-link': true,
        'logout-link--light': this.light,
      };
    },
  },

  methods: {
    logout() {
      this.$store.dispatch(`auth/${LOGOUT}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.logout-link {
  font-size: 15px;
  line-height: 1;
  margin-left: auto;
  color: var(--bf-color-dark);

  &__tasador {
    padding-right: 20px;
  }

  &__icon {
    cursor: pointer;
    margin-left: 8px;
  }

  &--light {
    color: var(--bf-color-light);
  }

  #app.-is-mobile & {
    .logout-link {
      &__user, &__tasador {
        display: none;
      }

      &__icon {
        font-size: 18px;
        margin-left: 0;
        padding: 4px;
      }
    }
  }
}
</style>
